import { useEffect, useRef } from "react";
import HighchartsReact from "highcharts-react-official";
import type { ClassificationBreakdownData } from "@components";

export const useDonutHoverSync = (
  data: ClassificationBreakdownData[],
  hoveredItem?: ClassificationBreakdownData | null
) => {
  const chartRef = useRef<HighchartsReact.RefObject>(null);

  useEffect(() => {
    const chart = chartRef.current?.chart;
    if (!chart) return;
    const points = chart.series[0]?.points;
    if (!points) return;

    const hoveredIndex = hoveredItem
      ? data.findIndex((d) => d.uid === hoveredItem.uid)
      : -1;
    const hovered = hoveredIndex >= 0 ? points[hoveredIndex] : null;

    requestAnimationFrame(() => {
      points.forEach((p, i) => {
        p.setState("");
        p.graphic?.css({
          opacity: hovered ? (i === hoveredIndex ? 1 : 0.5) : 1,
        });
      });

      if (hovered) {
        hovered.setState("hover");
        chart.tooltip.refresh(hovered);
      } else {
        chart.tooltip.hide();
      }
    });
  }, [hoveredItem, data]);

  return chartRef;
};
